module.exports = __webpack_public_path__ + "public/SiteImages/vector.png?d85457b8";